export default {
  SET_NOTIFICATION_SOCKET(state, socketConnection){
    state.notificationSocket = socketConnection
  }, 
  INSERT_A_NEW_NOTIFICATION(state, notification){
    state.notifications.set(notification?.id, notification) //sets new or updates
  },
  SET_NOTIFICATIONS(state, notifications){
    notifications.forEach(notification=>{
      state.notifications.set(notification?.id, notification)
    })
  },
  SET_NEW_NOTIFICATION_COUNT(state, count){
    state.newNotificationCount = count
  },
  INCREMENT_NEW_NOTIFICATION_COUNT(state){
    state.newNotificationCount++
  },
  SET_HAS_MORE_NOTIFICATION(state, hasMoreNotification){
    state.hasMoreNotification = hasMoreNotification
  },
  SET_NOTIFICATION_PAGE_COUNTER_NOTIFICATION(state, counter){
    state.notificationPage = counter
  }
};